export const ON_DEMAND = 'ON_DEMAND';
export const ON_DEMAND_PROFILE = 'ON_DEMAND_PROFILE';
export const CONFIGURABLE_CAPTURE_PERIOD = 'CONFIGURABLE_CAPTURE_PERIOD';
